import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 8rem 0 0 0;

    @media (min-width: 1600px) {
      margin: 8rem 0 0 0;
    }

    /* posição navegação */
    @media only screen and (max-width: 480px) {
      margin: 0 1rem 0 1rem;
    }
    @media only screen and (max-width: 978px) {
      margin: 0 1rem 0 1rem;
    }
  `}
`;

export const Topbar = styled.div`
  ${({ theme }) => css`
    height: 8rem;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    background-color: ${theme.colors.blueThird};

    padding-right: 4rem;
    display: flex;
    align-items: center;

    img {
      margin-left: 5rem;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.medium};
    line-height: 1.2;

    @media only screen and (max-width: 500px) {
      font-size: 1.3rem;
    }
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.grayFour};
    font-weight: bold;

    @media (min-width: 1600px) {
      font-size: ${theme.font.sizes.large};
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    width: 70%;
    height: 100%;
    margin: auto;
    margin-top: 15rem;
    padding-bottom: 1rem;
    border-bottom: 0.3rem solid ${theme.colors.lineBlue};
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media only screen and (max-width: 998px) {
      margin-top: 8rem;
    }
  `}
`;

export const BoxUser = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    align-items: center;

    ${Description} {
      color: ${theme.colors.gray};
      font-style: normal;
    }

    @media (min-width: 1600px) {
      margin-top: 1.8rem;
      ${Description} {
        font-size: ${theme.font.sizes.medium};
      }
    }
  `}
`;

export const Content = styled.div`
  max-width: 70%;
  margin: 0 auto;
  margin-top: 4rem;

  .imgWrapper {
    margin: 10rem 0 3rem 0;
    display: flex;
    flex-direction: column;
  }
  img {
    height: 7rem;
    margin: 0;
  }

  @media (max-width: 768px) {
    max-width: 90%;
  }

  @media (min-width: 768px) {
    max-width: 58%;
  }
`;

export const InputBox = styled.div`
  ${({ theme }) => css`
    margin-left: auto;
    margin-top: 5px;
    p {
      text-align: center;
      font-weight: bolder;
      color: ${theme.colors.grayFour};
    }
  `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-top: 6rem;
  width: 100%;

  @media (min-width: 1600px) {
    /* margin-top: 5rem; */
    margin-bottom: 11px;
    margin-top: 6rem;
    flex-wrap: inherit;
  }

  @media (max-width: 1600px) {
    flex-wrap: inherit;
  }
`;

export const SentText = styled.div`
  ${({ theme }) => css`
    text-align: center;
    font-size: ${theme.font.sizes.large};
    p {
      margin-top: 1rem;
      font-weight: bolder;
      color: ${theme.colors.grayFour};
    }
  `}
`;

export const Image = styled.img`
  ${({ theme }) => css`
    margin-right: 1.5rem;
    height: 3rem;
    color: ${theme.colors.lineBlue};

    @media (min-width: 1600px) {
      height: 4rem;
    }

    @media only screen and (max-width: 500px) {
      height: 2.8rem;
      margin-left: 2.2rem;
    }
  `}
`;

export const SkeletonInput = styled.h1`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.grayFour};
    width: 100%;
    margin-top: 7rem;
    margin-left: 11rem;
    .label {
      margin-left: 30%;
    }
  `}
`;
